import {IDeviceNode} from '../../shared/models/device';

export class NodeElement {
    public children: NodeElement[] = [];
    public readonly data: IDeviceNode;
    public parent: NodeElement;
    public $markedAsVisibleSection = false;
    public indent = 0;
    public hidableKeys: string[] = [];
    public categories: string[] = [];
    public skippedNode: NodeElement = null;

    constructor(parent: NodeElement, data: any) {
        this.parent = parent;
        this.data = data ? data : {};
    }

    public push(node: NodeElement) {
        if (!node) {
            return;
        }
        this.children.push(node);
        this.children = this.children.sort((a, b) => (a.data.order > b.data.order) ? 1 : ((b.data.order > a.data.order) ? -1 : 0));
    }

    public getNameAsString() {
        let name = '_';
        if (!this.parent) {
            name = 'root';
        }
        if (this.parent && this.parent.data && this.parent.data.displayText && this.parent.$markedAsVisibleSection) {
            name = this.parent.getNameAsString();
        }
        if (NodeElement.isFault(this.data)) {
            name = name + '/' + this.data.displayValue;
        }
        if (this.data && this.data.displayText) {
            name = name + '/' + this.data.displayText;
        }

        return name;
    }

    public getFullNameAsString() {
        let getName = (n: NodeElement) => {
            if (n.data && (this.data.displayText || this.data.displayValue)) {
                return this.data.displayText || this.data.displayValue;
            } else {
                return '_';
            }
        };
        return (this.parent ? this.parent.getFullNameAsString() : 'root') + '/' + getName(this);
    }

    public makeUnique() {
        let nearestListElement = NodeElement.findTopMostListElement(this);
        if (nearestListElement && nearestListElement.data && nearestListElement.data.displayText) {
            if (!nearestListElement.$markedAsVisibleSection) {
                NodeElement.indentChildren(nearestListElement.children, nearestListElement.data.displayText);
            }
            nearestListElement.$markedAsVisibleSection = true;
        } else if (this.data &&
            this.parent &&
            this.parent.data &&
            this.parent.data.displayText) {

            const realParent = this.skippedNode || this.parent;

            if (!realParent.$markedAsVisibleSection) {
                NodeElement.indentChildren(realParent.children, realParent.data.displayText);
                realParent.$markedAsVisibleSection = true;
            }
        }
    }

    private static isFault(data: IDeviceNode) {
        return data && data.graphicBehavior && data.displayText && 'FAULT' === data.displayText.toUpperCase();
    }

    private static indentChildren(children: NodeElement[], categoryName: string) {
        children.forEach(child => {
            if (child && child.data) {
                child.indent = child.indent + 1;
                child.categories.push(categoryName);
            }
            if (child.children && child.children.length > 0) {
                NodeElement.indentChildren(child.children, categoryName);
            }
        });
    }

    public addHidableKey(hidableKey: string) {
        this.hidableKeys.push(hidableKey);
        this.children.forEach(c => c.hidableKeys.push(hidableKey));
    }

    private static findTopMostListElement(node: NodeElement) {
        if (node.parent) {
            if (node.parent.parent && node.parent.parent['isNodeElementList']) {
                const top = NodeElement.findTopMostListElement(node.parent.parent);
                return top || node.parent;
            } else {
                return NodeElement.findTopMostListElement(node.parent);
            }
        } else {
            return null;
        }
    }
}
